(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    class AccordionWithLimit extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.itemsWrapper = this.querySelector('.accordion-items-wrapper');
      this.viewAllWrapper = this.querySelector('.view-all-wrapper');
      this.viewAllButton = this.querySelector('.view-all-link');
      this.initialLimit = parseInt(this.dataset.initialLimit) || 4;
      
      // Count direct children (accordion items)
      this.totalItems = this.itemsWrapper.children.length;
      
      // Initialize if more than limit
      if (this.totalItems > this.initialLimit) {
        this.itemsWrapper.classList.add('limited');
        this.viewAllWrapper.style.display = 'block';
        this.isExpanded = false;
        
        this.viewAllButton.addEventListener('click', () => {
          this.toggleViewAll();
        });
      }
    }
    
    toggleViewAll() {
      if (this.isExpanded) {
        // Collapse back to 4
        this.itemsWrapper.classList.add('limited');
        this.viewAllButton.textContent = 'View all';
        this.isExpanded = false;
      } else {
        // Expand to show all
        this.itemsWrapper.classList.remove('limited');
        this.viewAllButton.textContent = 'View less';
        this.isExpanded = true;
      }
    }
  }

  customElements.define('accordion-custom', AccordionWithLimit);
  } catch(e) { console.error(e); }
})();

})();
